import { render, staticRenderFns } from "./FaqContent.vue?vue&type=template&id=d950795e"
import script from "./FaqContent.vue?vue&type=script&lang=js"
export * from "./FaqContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports